/**
 * SizilPro — /proposal-builder/$id/view
 * Read-only detail view for a single proposal.
 * The $id.tsx route goes to the builder (edit).
 * This route goes to ProposalDetail (read/track).
 */

import { createFileRoute } from "@tanstack/react-router";
import { ProposalDetail } from "@/modules/proposal-builder/components/dashboard/ProposalDetail";

export const Route = createFileRoute("/proposal-builder/$id/view")({
  component: ProposalDetailRoute,
});

function ProposalDetailRoute() {
  const { id } = Route.useParams();
  return <ProposalDetail proposalId={id} />;
}
